import { Component, Input, OnInit } from '@angular/core';
import { ScApiService } from '@sc-ui';
import { forkJoin } from 'rxjs';
import { texts } from './project-pool.texts';
import { LocalizationService } from 'src/services/localization.service';
import { DemoService } from 'src/services/demo.service';

@Component({
  standalone: false,
  selector: 'app-project-pool',
  templateUrl: './project-pool.html',
  styleUrl: './project-pool.scss',
})
export class ProjectPool implements OnInit {

  texts = texts;

  @Input()
  project: any;

  // Hardcoded - no API yet. How the pool's candidates fit the project, in the pool's order.
  private demoMatches = [
    { MustHavesMet: 6, MustHavesTotal: 6, MissingMustHaves: [], SwitchSignal: true, Contacted: false },
    { MustHavesMet: 5, MustHavesTotal: 6, MissingMustHaves: ['Kubernetes'], SwitchSignal: false, Contacted: false },
    { MustHavesMet: 5, MustHavesTotal: 6, MissingMustHaves: ['Python'], SwitchSignal: false, Contacted: true },
    { MustHavesMet: 4, MustHavesTotal: 6, MissingMustHaves: ['Java', 'Microservices'], SwitchSignal: false, Contacted: false },
    { MustHavesMet: 4, MustHavesTotal: 6, MissingMustHaves: ['Java', 'Spring Boot'], SwitchSignal: false, Contacted: false },
    { MustHavesMet: 6, MustHavesTotal: 6, MissingMustHaves: [], SwitchSignal: true, Contacted: false },
    { MustHavesMet: 5, MustHavesTotal: 6, MissingMustHaves: ['Deutsch C1'], SwitchSignal: false, Contacted: true },
    { MustHavesMet: 4, MustHavesTotal: 6, MissingMustHaves: ['Java', 'Spring Boot'], SwitchSignal: true, Contacted: false }
  ];

  matches: any = [];

  kpis = { matches: 0, switchSignals: 0, contacted: 0 };

  constructor(private api: ScApiService,
    public loc: LocalizationService,
    public demo: DemoService) { }

  // the matches are the pool's candidates, with the job title and employer of their
  // profile, so each row tells what the candidate view it links to shows
  ngOnInit() {

    if (!this.demo.isActive) return;

    this.api.get('pool/candidates').subscribe((candidates: any) => {

      var matched = candidates.slice(0, this.demoMatches.length);

      forkJoin(matched.map(c => this.api.get(`candidates/${c.Id}`))).subscribe((profiles: any[]) => {

        this.matches = profiles.map((p, i) => Object.assign({}, p, this.demoMatches[i]));

        this.kpis = {
          matches: this.matches.length,
          switchSignals: this.matches.filter(m => m.SwitchSignal).length,
          contacted: this.matches.filter(m => m.Contacted).length
        };
      });
    });
  }

}
